export default "__VITE_ASSET__B$F5STiZ__"